<template>
  <div class="app">
    <div style="padding-right:8px;display:flex;position: fixed;z-index: 99;background-color:white;flex-direction: column;"
      v-if="isMobile">
      <div style="display:flex;">
        <div style="display:flex;align-items: center;justify-content: center;">
          <img src="./img/zhanshi.png" alt="logo" class="logo" />
        </div>
        <QiyeHeader :activeIndex="1" />
      </div>
      <div class="hengtiao">
        <div class="xiangji"><i class="el-icon-camera"></i></div>
        <div class="gerenxinxi">发布新职位</div>
      </div>
    </div>
    <div class="hengtiao1" v-if="!isMobile">
    </div>
    <div class="hengtiao" v-if="!isMobile">
      <div class="xiangji"><i class="el-icon-s-custom"></i></div>
      <div class="gerenxinxi">发布新职位</div>
    </div>
    <div class="head01">
      <QiyeHeader :activeIndex="1" v-if="!isMobile" />
      <div>
        <div class="neirong">
          <div class="head02">
            <div class="title">职位信息表</div>
            <div>
              <div class="jianju">
                <span class="span">所属行业：</span><el-select v-model="industryId" placeholder="所属行业" class="kuandu"
                  @change="handleIndustryChange" filterable>
                  <el-option v-for="industryItem in industries" :key="industryItem.industryId"
                    :label="industryItem.industryName" :value="industryItem.industryId" />
                </el-select>
              </div>
              <div class="jianju">
                <span class="span">职位名称：</span><el-select v-if="jobs.length > 0" v-model="jobName" placeholder="选择职位"
                  class="kuandu" filterable @change="handleJobChange">
                  <el-option v-for="job in jobs" :key="job.id" :label="job.jobName" :value="job.jobName" />
                </el-select><el-input v-else v-model="jobName" placeholder="请输入职位名称" class="kuandu" />
              </div>
              <div class="jianju">
                <span class="span">工作地点：</span><el-select v-model="workplace" placeholder="工作地点" class="kuandu"
                  :rules="[{ required: true, message: '工作地点', trigger: 'change' }]">
                  <!-- 遍历 workplaces 数组 -->
                  <el-option v-for="(item, index) in workplaces" :key="index" :label="item" :value="item"></el-option>
                </el-select>
              </div>
              <div class="jianju">
                <span class="span">薪资范围：</span>
                <el-input class="xinziwidth" type="text" v-model="form.minSalary" placeholder="最低值"></el-input>
                <el-input class="xinziwidth1" type="text" v-model="form.maxSalary" placeholder="最高值"></el-input>
              </div>
              <div class="jianju">
                <span class="span1">岗位职责：</span><el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
                  class="kuandu1" v-model="jobDuties" placeholder="岗位职责"></el-input>
              </div>
            </div>
          </div>
          <div class="xueliyaoqiu">
            <div class="title">职业要求</div>
            <div class="jianju">
              <span class="span">学历要求：</span>
              <el-radio-group v-model="degree" size="mini" style="margin-left: -5px;">
                <el-radio-button :label="null">不限</el-radio-button>
                <el-radio-button :label="'专科及以上'">专科</el-radio-button>
                <el-radio-button :label="'本科及以上'">本科</el-radio-button>
                <el-radio-button :label="'硕士及以上'">硕士</el-radio-button>
                <el-radio-button :label="'博士及以上'">博士</el-radio-button>
              </el-radio-group>
            </div>
            <div class="jianju">
              <span class="span">专业要求：</span><el-cascader v-model="major" @change="handleChange" placeholder="专业要求"
                :options="majors" :props="{
                  multiple: true,
                  emitPath: false
                }" filterable class="kuandu">
              </el-cascader>
            </div>
            <div class="jianju">
              <span class="span">证书要求：</span><el-input class="kuandu" v-model="certificate" placeholder="证书要求"></el-input>
            </div>
            <div class="title">技能标签</div>
            <div class="jianju">
              <span class="span">所需技能：</span><el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
                class="kuandu1" v-model="skills" placeholder="所需技能"></el-input>
            </div>
          </div>
        </div>
        <div class="dibu">
          <div class="qiyegangwei">企业岗位职业发布</div>
          <div class="baocuncss">
            <div class="save" @click="caogao">保存草稿</div>
            <div class="save" @click="save">发布职位</div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from './Footer.vue'
import QiyeHeader from './qiyeHeader.vue';
export default {
  name: 'newjob',
  components: {
    QiyeHeader,
    Footer
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.selectindustry()
    this.selectMajor()
    this.selectworkplace()
  },
  data() {
    return {
      industryId: null,
      jobName: '',
      workplace: '',
      workplaces: [],
      form: {
        minSalary: null,
        maxSalary: null
      },
      degree: '',
      majors: [],
      majordaima: '',
      major: '',
      certificate: '',
      skills: '',
      jobDuties: '',
      draft: 0,
      BASE_URL: 'https://zhiyedashi.com/job',
      BASE_URL1: 'https://zhiyedashi.com/info',
      BASE_URL2: 'https://zhiyedashi.com/school',
      // BASE_URL: 'http://192.168.2.8:8204',
      // BASE_URL1: 'http://192.168.2.8:8206',
      // BASE_URL2: 'http://192.168.2.8:8205',
      qiyeId: sessionStorage.getItem("qiyeId"),
      industries: [],
      jobs: [],
      hollandCode: '',
      isMobile: false
    }
  },
  created() {
    // 1. 判断关键数据是否存在
    if (!this.qiyeId) {
      // 2. 提前返回，跳过后续所有代码
      console.warn('关键数据未获取到，停止执行后续逻辑');
      this.$router.push('/')
    }
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    selectworkplace() {
      fetch(`${this.BASE_URL1}/admin/company/selectWorkplace`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `qiyeId=${this.qiyeId}`
      })
        .then(res => res.json())
        .then(data => {
          this.workplaces = JSON.parse(data.data)
        })
        .catch(error => {
          console.error("查询失败，原因是", error);
        });
    },
    selectMajor() {
      fetch(`${this.BASE_URL2}/admin/api/majors`)
        .then(res => res.json())
        .then(data => {
          // console.log("专业", data.data);
          this.majors = data.data
        })
        .catch(error => {
          console.error("查询失败，原因是", error);
        });
    },
    handleJobChange(selectedJobName) {
      const selectedJob = this.jobs.find(job => job.jobName === selectedJobName);
      // console.log("岗位名称", selectedJob);

      if (selectedJob) {
        this.hollandCode = selectedJob.hollandCode
        this.jobDuties = selectedJob.positionDescription || '';
        this.degree = selectedJob.degreeRequirement || '';
        this.industryId = selectedJob.industryId
        if (selectedJob.jobResponsibilities) {
          try {
            this.jobDutiesArray = JSON.parse(selectedJob.jobResponsibilities);
            this.jobDuties = this.jobDutiesArray.join('\n');
          } catch (e) {
            console.error("解析 jobResponsibilities 失败:", e);
            this.jobDutiesArray = [];
            this.jobDuties = '';
          }
        } else {
          this.jobDutiesArray = [];
          this.jobDuties = '';
        }
        if (selectedJob.certificates) {
          try {
            this.certificateArray = JSON.parse(selectedJob.certificates); // 解析 JSON 字符串为数组
            this.certificate = this.certificateArray.join(', '); // 数组转字符串，用逗号+空格分隔
          } catch (e) {
            console.error("解析 certificates 失败:", e);
            this.certificateArray = [];
            this.certificate = '';
          }
        } else {
          this.certificateArray = [];
          this.certificate = '';
        }
        if (selectedJob.majorSkills) {
          try {
            this.skillsArray = JSON.parse(selectedJob.majorSkills);
            this.skills = this.skillsArray.join('\n');
          } catch (e) {
            console.error("解析 jobResponsibilities 失败:", e);
            this.skillssArray = [];
            this.skills = '';
          }
        } else {
          this.skillsArray = [];
          this.skills = '';
        }
        this.form.minSalary = selectedJob.jobSalaryMin;
        this.form.maxSalary = selectedJob.jobSalaryMax;
      }
    },
    handleIndustryChange(value) {
      // 查询所有岗位
      fetch(`${this.BASE_URL}/admin/jobliebiao/selectJob`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `industryId=${value}`
      })
        .then(res => res.json())
        .then(data => {
          // console.log("岗位", data.data);
          if (data.data !== '暂无数据') {
            this.jobs = data.data
          }
        })
        .catch(error => {
          console.error("查询失败，原因是", error);
        });
    },
    selectindustry() {
      // 查询所属行业
      fetch(`${this.BASE_URL}/admin/industry/selectIndustry`, {
        method: 'POST'
      })
        .then(res => res.json())
        .then(data => {
          this.industries = data.data
        })
        .catch(error => {
          console.error("查询失败，原因是", error);
        });
    },
    handleChange(value) {
      const selectedLabels = [];

      // 遍历每个选中的 value
      value.forEach(val => {
        // 递归查找函数
        const findLabel = (options) => {
          for (const option of options) {
            // 如果当前节点的 value 匹配
            if (option.value === val) {
              return option.label;
            }
            // 如果有子节点，递归查找
            if (option.children && option.children.length > 0) {
              const found = findLabel(option.children);
              if (found) return found;
            }
          }
        };

        // 在 majors 中查找
        const label = findLabel(this.majors);
        if (label) {
          selectedLabels.push(label);
        }
      });
      this.majordaima = JSON.stringify(selectedLabels)
    },
    caogao() {
      this.baocun(1)
    },
    save() {
      this.baocun(0)
    },
    baocun(type) {
      const jobResponsibilities = this.jobDuties
        ? JSON.stringify(this.jobDuties.split('\n').filter(item => item.trim() !== ''))
        : JSON.stringify([]); // 空值时存为空数组的 JSON 字符串

      // 2. 处理证书（逗号分隔 → 数组 → JSON 字符串）
      const certificates = this.certificate
        ? JSON.stringify(this.certificate.split(',').map(item => item.trim()).filter(item => item !== ''))
        : JSON.stringify([]);

      // 3. 处理专业技能（换行符分隔 → 数组 → JSON 字符串）
      const majorSkills = this.skills
        ? JSON.stringify(this.skills.split('\n').filter(item => item.trim() !== ''))
        : JSON.stringify([]);
      let qiyeJob = {
        industryId: this.industryId,
        hollandCode: this.hollandCode,
        qiyeId: this.qiyeId,
        jobName: this.jobName,
        workplace: this.workplace,
        minSalary: this.form.minSalary,
        maxSalary: this.form.maxSalary,
        jobDuties: jobResponsibilities,
        degree: this.degree,
        major: this.majordaima,
        certificate: certificates,
        skills: majorSkills,
        draft: type
      }
      // console.log("qiyeJob", qiyeJob)
      fetch(`${this.BASE_URL}/admin/qiyejob/saveJob`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(qiyeJob)
      })
        .then(res => res.json())
        .then(data => {
          if (data.code === 200 && data.data === '保存成功') {
            alert("保存成功")
            this.$router.push('/JobBoard');
          }
        })
        .catch(error => {
          console.error("保存失败", error);
        })
    }
  }
}
</script>
<style scoped>
.hengtiao1 {
  height: 8px;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
}

.hengtiao {
  height: 50px;
  width: 100%;
  background-color: #3572e5;
  color: white;
  display: flex;
  align-items: center;
}

.xiangji {
  margin-left: 20px;
  font-weight: 800;
  font-size: 28px;
}

.gerenxinxi {
  margin-left: 20px;
  font-weight: 700;
}

.head01 {
  display: flex;
  gap: 180px;
}

.head02 {
  height: 550px;
  width: 430px;
  border: 1px solid #DCDFE6;
  border-radius: 15px;
}

.neirong {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 25px;
  margin-top: 50px;
}

.xueliyaoqiu {
  height: 550px;
  width: 430px;
  border: 1px solid #DCDFE6;
  border-radius: 15px;
}

.title {
  font-size: 20px;
  font-weight: 700;
  margin-top: 10px;
  text-align: left;
  margin-left: 15px;
}

.span {
  margin-right: 7px;
  width: 80px;
  display: inline-block;
  text-align: right;
}

.xinziwidth {
  width: 146px;
  margin-left: -5px;
}

.xinziwidth1 {
  width: 146px;
}

.span1 {
  margin-right: 7px;
  width: 80px;
  display: inline-block;
  text-align: right;
}

.jianju {
  margin-top: 15px;
  margin-left: -15px;
  font-size: 16px;
  font-weight: 500;
}

.kuandu {
  width: 296px;
}

.kuandu1 {
  width: 284px;
}

.shili {
  border: 1px solid #DCDFE6;
  width: 352px;
  border-radius: 10px;
  margin-left: 17px;
  text-align: left;
  padding: 5px 15px;
  margin-top: 15px;
}

.dibu {
  margin-top: 100px;
  background-color: #2f3e5d;
  height: 150px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.qiyegangwei {
  font-weight: 700;
  font-size: 24px;
  color: white;
}

.baocuncss {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  margin-top: 20px;
}

.save {
  background-color: #3572e5;
  height: 40px;
  width: 140px;
  border-radius: 50px;
  color: white;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 768px) {
  .logo {
    width: 50px;
  }

  .hengtiao {
    height: 50px;
    width: 100%;
    background-color: #3572e5;
    color: white;
    display: flex;
    align-items: center;
  }

  .head01 {
    flex-direction: column;
    gap: 20px;
    padding-top: 140px;
  }

  .neirong {
    flex-direction: column;
    gap: 20px;
    margin-top: 10px;
    padding: 0 15px;
  }

  .head02,
  .xueliyaoqiu {
    width: 100%;
    height: 388px;
    margin: 0 auto;
  }

  .title {
    font-size: 18px;
    margin-left: 10px;
    margin-top: 15px;
  }

  .jianju {
    margin-left: 0;
    padding: 0 15px;
  }

  .kuandu,
  .kuandu1 {
    width: 100%;
    max-width: 209px;
  }

  .span,
  .span1 {
    width: 70px;
    font-size: 14px;
  }

  .xinziwidth,
  .xinziwidth1 {
    width: 102px;
  }

  .dibu {
    margin-top: 0px;
    height: 120px;
    padding: 15px 0;
    width: 100%;
  }

  .qiyegangwei {
    font-size: 20px;
    text-align: center;
  }

  .baocuncss {
    gap: 15px;
    margin-top: 30px;
  }

  .save {
    width: 120px;
    height: 45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newjob.vue